import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import UILocale from '../../../../utils/UILocale';

const ProductAvailability = (props) => {
  const renderAvailabilityForSHDProduct = () => (
    <>
      {props.canBeHomeDelivered
        ? (
          <span className={'available'}>
            <i className={'dcg-icon-tick'} />
            {' '}
            {UILocale.getString('dynamic.bundles.mci_available_home_deliv_shd')}
          </span>
        )
        : (
          <span className={'unavailable'}>
            <i className={'dcg-icon-cross'} />
            {' '}
            {UILocale.getString('dynamic.bundles.mci_unavailable_home_deliv_shd')}
          </span>
        )}
      <span className={'unavailable'}>
        <i className={'dcg-icon-cross'} />
        {' '}
        {UILocale.getString('dynamic.bundles.mci_unavailable_store_collect_shd')}
      </span>
    </>
  );

  const renderAvailabilityForDownloadableProduct = () => (
    <span className={'available'}>
      <i className={'dcg-icon-download'} />
      {' '}
      {UILocale.getString('dynamic.bundles.mci_available_download')}
    </span>
  );

  const renderDeliveryForRegularProduct = () => {
    if (props.canBeHomeDelivered && !props.isForwardOrderable && !props.isPreOrderable) {
      return (
        <span className={'available'}>
          <i className={'dcg-icon-tick'} />
          {' '}
          {UILocale.getString('dynamic.bundles.mci_available_home_deliv')}
        </span>
      );
    } if (props.canBeHomeDelivered && (props.isForwardOrderable || props.isPreOrderable)) {
      return (
        <span className={'available'}>
          <i className={'dcg-icon-tick'} />
          {' '}
          {UILocale.getString('dynamic.bundles.mci_deliv_available_from')}
          {' '}
          {props.Dispo}
        </span>
      );
    }

    return (
      <span className={'unavailable'}>
        <i className={'dcg-icon-cross'} />
        {' '}
        {UILocale.getString('dynamic.bundles.mci_unavailable_home_deliv')}
      </span>
    );
  };

  const renderCollectabilityForRegularProduct = () => (
    props.canBeReservedandCollected || props.canBePayedAndCollected
      ? (
        <span className={'available'}>
          <i className={'dcg-icon-tick'} />
          {' '}
          {UILocale.getString('dynamic.bundles.mci_available_store_collect')}
        </span>
      )
      : (
        <span className={'unavailable'}>
          <i className={'dcg-icon-cross'} />
          {' '}
          {UILocale.getString('dynamic.bundles.mci_unavailable_store_collect')}
        </span>
      )
  );


  return (
    <span className={'availability'}>
      {props.bIsSHD && renderAvailabilityForSHDProduct()}
      {!props.bIsSHD && props.canBeDownloaded && renderAvailabilityForDownloadableProduct()}
      {!props.bIsSHD && !props.canBeDownloaded && renderDeliveryForRegularProduct()}
      {!props.bIsSHD && !props.canBeDownloaded && renderCollectabilityForRegularProduct()}
    </span>
  );
};


ProductAvailability.propTypes = {
  bIsSHD: PropTypes.bool.isRequired,
  canBeHomeDelivered: PropTypes.bool.isRequired,
  canBeDownloaded: PropTypes.bool.isRequired,
  isForwardOrderable: PropTypes.bool.isRequired,
  isPreOrderable: PropTypes.bool.isRequired,
  canBeReservedandCollected: PropTypes.bool.isRequired,
  canBePayedAndCollected: PropTypes.bool.isRequired,
  Dispo: PropTypes.string
};

ProductAvailability.defaultProps = {
  Dispo: ''
};

export default ProductAvailability;
